/// <reference path="../modules/app.module.ts" />

module App {
    export interface IStopEvent extends ng.IDirective {

    }
    export class StopEvent implements IStopEvent {
        static directiveId: string = "stopEvent";

        restrict: string = "A";
        
        constructor() {

        }

        link = (scope, element, attr) => {
            if (attr && attr.stopEvent)
                element.bind(attr.stopEvent, (e) => {
                    e.stopPropagation();
                });
        }
    }

    app.directive(StopEvent.directiveId, [() => new StopEvent()]);
}